import { render } from "./product-requirements.vue?vue&type=template&id=4a47f4e0&lang=html"
import script from "./product-requirements.vue?vue&type=script&lang=js"
export * from "./product-requirements.vue?vue&type=script&lang=js"

import "./product-requirements.vue?vue&type=style&index=0&id=4a47f4e0&lang=less"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__